export default {
  title: "Transaction History",
  number: "Number",
  entityName: "Organization Name",
  type: "Transaction Type",
  typeBuyTariff: "Tariff Purchase",
  typeAddBalance: "Balance Top-up",
  typePaymentAct: "Invoice Payment",
  typePaymentAcceptance: "Test Payment",
  amount: "Amount",
  currency: "Currency",
  date: "Date and Time",
  noHistory: "Your history is empty",
  operationsTab: "All Transactions",
  processingTab: "RC Processing",
  reward: "Reward",
  paidFromPurchase:
    "{cash} {currency} paid <span>(from purchase of {amount} {currency})</span>",
  downloadModal: {
    title: "Download File",
    fileType: "File Type",
    sendOnEmail: "Send copy to email",
    CPUnloadingOperationHistory: "(CP) Transaction History Export",
  },
  couldntCreateUnloading: "Could not create export",
  giftCard: "Gift Card",
  orderNumber: "Order Number",
  paymentMethod: "Payment Method",
  inCheckSpecifiedPercentAndSumAward:
    "The receipt shows the total percentage and reward amount.",
  itsMayNotMatchWithFactSum:
    "It may not match the amount of points actually debited, as it depends on which customer made the purchase (internal or external) and their tariff.",
};
